import axios from "axios";

export const PORTAL_TOKEN_KEY = "clover_anak_token";

export const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const s = err.response?.status;
    const url = err.config?.url || "";
    if ((s === 401 || (s === 403 && url.includes("/portal/me"))) && !url.includes("/portal/login")) {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      window.dispatchEvent(new Event("clover-portal-logout"));
    }
    return Promise.reject(err);
  }
);
